// Shared helpers/components for the OWNER admin area.
import React from "react";

export const brl = (cents = 0) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format((cents || 0) / 100);

export const num = (n = 0) => new Intl.NumberFormat("pt-BR").format(n || 0);

export const dt = (iso = "") => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export const dOnly = (iso = "") => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("pt-BR"); } catch { return iso; }
};

export function Card({ title, kicker, right, className = "", children, testid }) {
  return (
    <section
      data-testid={testid}
      className={`rounded-2xl border border-white/5 bg-[#111726]/70 backdrop-blur-sm shadow-[0_10px_30px_rgba(0,0,0,0.35)] ${className}`}
    >
      {(title || right) && (
        <header className="flex items-center justify-between px-5 py-3 border-b border-white/5">
          <div>
            {kicker && <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500">{kicker}</div>}
            {title && <div className="text-slate-100 font-semibold">{title}</div>}
          </div>
          {right}
        </header>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}

export function KPI({ label, value, delta, hint, tone = "gold", testid }) {
  const toneMap = {
    gold: "text-[#d4a24c]",
    green: "text-emerald-400",
    red: "text-rose-400",
    blue: "text-sky-400",
    purple: "text-violet-400",
  };
  const good = delta != null && delta >= 0;
  return (
    <div className="rounded-2xl border border-white/5 bg-[#111726]/70 p-5 shadow-[0_10px_30px_rgba(0,0,0,0.35)]" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500">{label}</div>
      <div className={`mt-2 text-3xl font-semibold ${toneMap[tone] || "text-slate-100"}`}>{value}</div>
      <div className="mt-1 flex items-center gap-2 text-xs">
        {delta != null && (
          <span className={good ? "text-emerald-400" : "text-rose-400"}>
            {good ? "▲" : "▼"} {Math.abs(delta).toFixed(1)}%
          </span>
        )}
        {hint && <span className="text-slate-500">{hint}</span>}
      </div>
    </div>
  );
}

export function Pill({ children, tone = "slate", testid }) {
  const tones = {
    slate: "bg-slate-800/60 text-slate-300 border-slate-700",
    green: "bg-emerald-900/40 text-emerald-300 border-emerald-800/60",
    red: "bg-rose-900/40 text-rose-300 border-rose-800/60",
    amber: "bg-amber-900/40 text-amber-300 border-amber-800/60",
    gold: "bg-[#3a2a15] text-[#d4a24c] border-[#4b3a20]",
  };
  return <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] border ${tones[tone] || tones.slate}`}>{children}</span>;
}

export function PageHeader({ title, subtitle, right }) {
  return (
    <header className="flex items-start justify-between mb-6" data-testid="admin-page-header">
      <div>
        <div className="text-[11px] uppercase tracking-[0.28em] text-[#d4a24c]/80">Hermes · Owner</div>
        <h1 className="text-3xl font-serif text-slate-100 mt-1">{title}</h1>
        {subtitle && <p className="text-slate-400 text-sm mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{right}</div>
    </header>
  );
}
